import {
  mountConfiguratorApplication,
  mountStandaloneAdminApplication,
} from '@salsita-ai/platform-project-sdk/application'

import config from './config'

mountConfiguratorApplication(config)
mountStandaloneAdminApplication(config)
